import * as React from 'react'

import { FieldInputProps, FormikProps, FormikValues } from 'formik'

import CheckboxInput from '../ui/checkboxInput'
import './form.sass'

interface Props {
    label: string
    field: FieldInputProps<string>
    form: FormikProps<FormikValues>
    onChangeCallback?: (form: FormikProps<FormikValues>) => void
    noWrap?: boolean
}

const CheckboxField: React.FunctionComponent<Props> = ({ form, field, label, onChangeCallback, noWrap }: Props) => {
    return (
        <div className="form__fieldContainer">
            <CheckboxInput
                noWrap={noWrap}
                {...field}
                label={label}
                id={field.name}
                checked={!!field.value}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    form.setFieldValue(field.name, e.target.checked ? 1 : 0)
                    onChangeCallback && onChangeCallback(form)
                }}
            />
        </div>
    )
}

export default CheckboxField
